export namespace HarloweSupport 
{

    export class File
    {
        constructor
        (
            public id: number,
            public fileName: string,
            public fileCategory: string,
            public fileType: string
        )
        {}

        get FileNameAndType() : string
        {
            return this.fileName + " <" + this.fileCategory + "> (" + this.fileType + ")";
        }
    }
}